module.exports = __webpack_public_path__ + "img/banner.df986424.jpg";